import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Leaf, Recycle } from "lucide-react";
export default function StartYourWasteRecyclingServiceToday() {
  return <section className="relative min-h-screen flex items-center justify-center bg-primary-dark-bg !h-[650px]">
      {}
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="animate-fade-up">
          {}
          

          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1409808/img/columbia_valley_waste_logo_placeholder.png" alt="Columbia Valley Waste & Recycling Logo" className="h-7 mx-auto mb-4" />
          <img src="https://columbiavalleywaste.com/wp-content/uploads/2025/11/cropped-cropped-cropped-CVWR.png" alt="Waste and Recycling Service" className="mx-auto mb-6 !w-[200px] !h-[200px]" />
          <h1 className="text-white leading-snug mb-4 !text-5xl !font-bold">Secure Your Junk Removal&nbsp;<div data-ast-id="f:/src/pages/SignUp/sections/StartYourWasteRecyclingServiceToday.tsx|sig:5nowp6" data-ast-start="1028" data-ast-end="1052" contenteditable="false" style={{}}>Service Today</div></h1>

          {}
          <p className="text-lg md:text-xl text-white/95 leading-relaxed mb-8 max-w-2xl mx-auto">Proudly serving Calgary, Radium, Invermere, Windermere, Fairmont Hot Springs, and surrounding communities.</p>

          {}
          <Button asChild size="lg" className="bg-accent text-black font-semibold py-3 px-6 rounded-md shadow-md hover:bg-accent/90 hover:shadow-lg hover:scale-105 transition-all duration-200 ease-out focus-visible:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">
            
          </Button>
        </div>
      </div>
    </section>;
}